<template>
  <div>
    <!-- Title -->
    <title-view>
      {{ $t('contact_9') }}
    </title-view>

    <!-- Contacts -->
    <div class="page-contact-form__contacts grid-center">
      <!-- Boston -->
      <contact-view class="col-4_md-12">
        <template slot="title">
          {{ $t('footer_6') }}
        </template>

        <template slot="subtitle">
          <a :href="getPhone($t('project_3'))">
            {{ $t('project_3') }}
          </a>
        </template>
      </contact-view>

      <!-- Lisbon -->
      <contact-view class="col-4_md-12">
        <template slot="title">
          {{ $t('footer_9') }}
        </template>

        <template slot="subtitle">
          <a :href="getPhone($t('project_4'))">
            {{ $t('project_4') }}
          </a>
        </template>
      </contact-view>

      <!-- Copenhagen -->
      <contact-view class="col-4_md-12">
        <template slot="title">
          {{ $t('footer_11') }}
        </template>

        <template slot="subtitle">
          <a :href="getPhone($t('project_4'))">
            {{ $t('project_12') }}
          </a>
        </template>
      </contact-view>
    </div>

    <!-- Form -->
    <contact-form-view />

    <!-- Email -->
    <section class="page-contact-form__email">
      <contact-view
        class="col-4_md-12"
        variant="invert"
      >
        <template slot="title">
          {{ $t('project_10') }}
        </template>

        <template slot="subtitle">
          <a :href="getEmail($t('project_5'))">
            {{ $t('project_5') }}
          </a>
        </template>
      </contact-view>
    </section>

    <section class="grid-noGutter">
      <!-- Lisbon -->
      <contact-full-view
        v-for="(contact,index) in $t('contacts_list')"
        :key="index"
        class="col-6_xs-12"
      >
        <!-- Image -->
        <template slot="image">
          <picture>
            <source
              media="--small"
              :alt="contact.imageAlt"
              :data-srcset="contact.image.small"
            >

            <source
              media="--large"
              :alt="contact.imageAlt"
              :data-srcset="contact.image.large"
            >

            <img
              class="lazyload"
              data-sizes="auto"
              :alt="contact.imageAlt"
              :data-src="contact.image.src"
            >
          </picture>
        </template>

        <!-- Header -->
        <template slot="header">
          {{ contact.title }}
        </template>

        <!-- Detail -->
        <template slot="detail">
          <div
            v-for="(infoLocal, i) in contact.street"
            :key="i"
          >
            {{ infoLocal }}
          </div>
          <br>
          <a :href="contact.link.href">{{ contact.link.number }}</a>
        </template>

        <!-- Map -->
        <template slot="map">
          <a
            :href="contact.map"
            target="_blank"
            rel="noopener noreferrer"
          >

            <button-view variant="small">
              {{ $t('button_3') }}
            </button-view>

          </a>
        </template>
      </contact-full-view>
    </section>

    <footer-follow-view />
  </div>
</template>

<script>
export default {
  name: 'PageContact',

  components: {
    TitleView: () => import('@/components/title/title-view'),
    ContactView: () => import('@/components/contact/contact-view'),
    ContactFormView: () => import('@/components/contact/contact-form-view'),
    ButtonView: () => import('@/components/button/button-view'),
    ContactFullView: () => import('@/components/contact/contact-full-view'),
    FooterFollowView: () => import('@/components/footer/footer-follow-view')
  },

  metaInfo: {
    title: 'Contact Us: Have a project in mind? We’re here to help.',
    meta: [
      {
        name: 'description',
        content: 'We know figuring out all the details of a project can be tough. Let’s chat about your project so we can help make your life Bliss!'
      },
      {
        property: 'og:url',
        content: 'https://www.blissapplications.com/contact'
      },
      {
        property: 'og:title',
        content: 'Contact Us: Have a project in mind? We’re here to help.'
      },
      {
        property: 'og:description',
        content: 'We know figuring out all the details of a project can be tough. Let’s chat about your project so we can help make your life Bliss!'
      },
      {
        property: 'og:image',
        content: 'https://drive.google.com/file/d/135aIMh5U9N4BSuF0mYkaRy2nx6LCpq1h/view?usp=sharing'
      },
      {
        name: 'twitter:title',
        content: 'Contact Us: Have a project in mind? We’re here to help.'
      },
      {
        name: 'twitter:description',
        content: 'We know figuring out all the details of a project can be tough. Let’s chat about your project so we can help make your life Bliss!'
      },
      {
        name: 'twitter:image',
        content: 'https://drive.google.com/file/d/135aIMh5U9N4BSuF0mYkaRy2nx6LCpq1h/view?usp=sharing'
      }
    ]
  },

  mounted() {
    if (window.location.hash !== '#details') {
      return;
    }

    setTimeout(() => {
      this.$scrollTo('#details');
    }, 500);
  },

  methods: {
    getPhone(phone) {
      return `tel:${phone}`;
    },

    getEmail(email) {
      return `mailto:${email}`;
    }
  }
};
</script>

<style lang="scss" src="../assets/pages/contact-form.scss"></style>



// WEBPACK FOOTER //
// contact.vue